// The facesheet header's divider dot color, under
// featureFlags.facesheetHeaderDotDividers.
//
// Light is stone-300, the day center schedule row's dot — the spec Gio asked
// every divider in the header to match. Dark is its counterpart: stone-300 is a
// fixed 83% lightness, so on the dark card it renders *brighter* than the 65%
// text it separates, inverting the "quieter than the text" reading the light
// theme has. stone-700 sits the same distance below the dark card's background
// as stone-300 sits below white, which is the relationship the theme's own
// --foreground-tertiary keeps across the two themes.
//
// One constant because "the same dot and color everywhere" is the requirement,
// and six copies of a literal is how the dark value went missing to begin with.
export const DIVIDER_DOT_COLOR_CLASS = 'text-[#d6d3d1] dark:text-[#44403c]'
